<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-06 15:03:01
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-08-29 16:52:59
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\components\xm-tenant-select.vue
* @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import { DownOutlined } from '@ant-design/icons-vue';
import {
  Dropdown as ADropdown,
  Menu as AMenu,
  MenuItem as AMenuItem
} from 'ant-design-vue'

import XmTenantModal from './xm-tenant-modal.vue'

import { useXmTenantDropdownStore } from '../stores/xm-tenant-dropdown';
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import {loadCurUserIdentity,getSystemConfigObj} from "xmgoing-server";
import {QueryCommand} from "xmgoing-server";
import {jumpPageByPosition} from "@/layouts/default/header/components/hooks/useSwitchTenant";
import { useAppFrame } from '@/hooks/useAppFrame';

const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();

const XmTenantDropdownStore = useXmTenantDropdownStore()
const {
  currentTitle,
  dropdownProps,
  menuProps,
  tenantList,
} = storeToRefs(XmTenantDropdownStore)

const {
  onSelect
}:any = XmTenantDropdownStore;

const accountSwitchFlag=ref(true);
const inputPwdSwitchFlag=ref(false);
const zhutiSwitchFlag=ref(false);
onMounted(() => {
  //根据配置来显示 是否切换商户帐套
  try {
    const {accountSwitch, zhutiSwitch, inputPwdSwitch} = getSystemConfigObj();
    inputPwdSwitchFlag.value = GoingNewUtils.parseBoolean(inputPwdSwitch);
    //获取租户切换的标志
    accountSwitchFlag.value = GoingNewUtils.parseBoolean(accountSwitch);
    //主体切换标志
    zhutiSwitchFlag.value=GoingNewUtils.parseBoolean(zhutiSwitch);
    //如果租户切换为空 但主体切换又不为空 则还是需要显示
    if (accountSwitchFlag.value === false && GoingNewUtils.parseBoolean(zhutiSwitch)) {
      accountSwitchFlag.value = true;
    }
    //如果存在主体切换 才判断是否为商户 还是为主体
    if(GoingNewUtils.parseBoolean(zhutiSwitch)){
      loadCurUserIdentity().then((identity) => {
        // 如果是商户管理员 则不显示切换帐套功能
        if (identity === 'merchant') {
          accountSwitchFlag.value = false;
        } else {
          accountSwitchFlag.value = true;
        }
      });
    }
  } catch (e) {

  }


})

/**
 * 无需输入密码进行切换操作
 */
const changeZhutiAccountByNoPwd=function ({selectedKeys, keyPath}){
  //直接切换主体
  const queryCommand = new QueryCommand({
    url: `/api/pe-portal/tenantIndustryType/user/switchSubject`,
    method: 'POST',
  });
  queryCommand.executeQueryPromise({params:{tenantId:unref(selectedKeys)[0]}}).then((backData)=>{
    jumpPageByPosition(backData.position, backData.access_token, backData.user_id);
  },(e)=>{
    console.error(e,"==========");
  });
}

/**
 * 无密码租户切换
 * @param selectedKeys
 * @param keyPath
 */
const changeAccountByNoPwd=function ({selectedKeys}){
  //直接切换主体
  const queryCommand = new QueryCommand({
    url: `/api/pe-portal/user/switchLogin`,
    method: 'POST',
  });
  queryCommand.executeQueryPromise({params:{tenantId:unref(selectedKeys)[0]}}).then((backData)=>{
    jumpPageByPosition(backData.position, backData.access_token, backData.user_id);
  },(e)=>{
    console.error(e,"==========");
  });
}

//选择下拉
const selDropMenu=function ({selectedKeys, keyPath}){
  if(unref(inputPwdSwitchFlag)){
    onSelect({selectedKeys, keyPath});
  }else{
    if(unref(zhutiSwitchFlag)){
      //无密码切换
      changeZhutiAccountByNoPwd({selectedKeys, keyPath});
    }else{
      //无密码切换
      changeAccountByNoPwd({selectedKeys});
    }
  }
}
</script>

<template>
  <ADropdown v-if="accountSwitchFlag&&tenantList.length>0" v-bind="dropdownProps">
    <a class="ant-dropdown-link" :style="getTechnologyFrameTextColor" v-if="isFrameType" @click.prevent>
        <span class="cur-account-label">{{ currentTitle||'' }}</span>
        <span :style="isFrameType ? getTechnologyFrameTextColor : ''" :class="['remix-icon', 'ri-arrow-down-s-line', isFrameType ? 'remix-icon-text' : '']"> </span>
      </a>
      <a class="ant-dropdown-link" v-else @click.prevent>
        <span class="cur-account-label">{{ currentTitle||'' }}</span>
        <DownOutlined />
      </a>
    <template #overlay>
      <AMenu class="xm-tenant-dropdown" style="min-width: 140px;" v-bind="menuProps" @select="selDropMenu">
        <template v-if="!zhutiSwitchFlag" v-for="item of tenantList" :key="item.value">
          <AMenuItem  :title="item.title">
            <div class="user-item-div" style="line-height: 30px;">
              <div class="flex-div" style="width:280px;">
                <div class="lable-div">
                  所属公司：
                </div>
                <div  style="flex: 1;width:calc(100% - 80px)" class="label-content text-dian-dian">
                  {{item.tenantName}}
                </div>
              </div>

              <div class="flex-div" style="width:280px;">
                <div class="lable-div">
                  姓名：
                </div>
                <div  style="flex: 1;width:calc(100% - 80px)" class="label-content text-dian-dian">
                  {{item.realName}}
                </div>
              </div>

              <div class="flex-div" style="width:280px;">
                <div class="lable-div">
                  角色：
                </div>
                <div style="flex: 1;width:calc(100% - 80px)" class="label-content text-dian-dian">
                  {{item.roleName}}
                </div>
              </div>

              <!--           <div class="flex-div" style="width:280px;">-->
              <!--             <div class="lable-div">-->
              <!--               部门：-->
              <!--             </div>-->
              <!--             <div class="label-content">-->
              <!--               {{item.deptName}}-->
              <!--             </div>-->
              <!--           </div>-->

            </div>
          </AMenuItem>
        </template>
        <template v-else>
            <AMenuItem v-for="item of tenantList" :key="item.value" :title="item.title">
              <a href="javascript:;">{{ item.label }}</a>
            </AMenuItem>
        </template>
      </AMenu>
    </template>
  </ADropdown>

  <XmTenantModal />
</template>

<style lang="less" scoped>
.ant-dropdown-link {
  padding: 0 6px;
  font-size: 14px !important;
  color: var(--el-text-color-primary, #0a001f);
}
.vben-layout-multiple-header--dark{
  .cur-account-label,.anticon{
    color:#FFF;
  }
}
.vben-layout-multiple-header--light{
  .cur-account-label,.anticon {
    color:#333;
  }
}
.user-item-div{
  .lable-div{
    width:80px;
    text-align: right;
  }
  .text-dian-dian{
    text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
    white-space: nowrap; /*让文字不换行*/
    overflow: hidden; /*超出要隐藏*/
  }
  .label-content{
    font-weight: 500;
  }
}
.xm-tenant-dropdown{
  min-width: 140px;
  max-height: 450px;
  overflow: auto;
}
</style>
